import React, { useState, useEffect } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import axios from "axios";

const IFrame = (props) => {
  //========================================================================
  // Zustandsvariablen definieren

  //========================================================================
  // Logik
  const getFullUrl = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "http://" + url;
    }
    return url;
  };

  const url = getFullUrl(props.element.url);

  //========================================================================
  // Grafische Darstellung
  return (
    <iframe
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      src={url}
    />
  );
};

export default IFrame;
